module.exports = __webpack_public_path__ + "static/media/no-solutions.4cae8a2c.svg";